(() => {
  const boot = () => {
    const root = document.querySelector('[data-hg-design-studio]');
    if (!root || root.dataset.ready === '1') return;
    if (!window.Konva) { setTimeout(boot, 120); return; }
    root.dataset.ready = '1';

    const $ = s => root.querySelector(s);
    const $$ = s => [...root.querySelectorAll(s)];

    const stageEl = $('[data-stage]');
    const titleEl = $('[data-canvas-title]');
    const helpEl = $('[data-canvas-help]');
    const projectHidden = $('[data-hidden-project]');
    const designHidden = $('[data-hidden-design]');
    const filesHidden = $('[data-hidden-files]');
    const form = $('#HGDesignStudioQuote');
    const textValue = $('[data-text-value]');
    const fontSelect = $('[data-font]');
    const colorInput = $('[data-color]');
    const fontSize = $('[data-font-size]');
    const layersList = $('[data-layers-list]');
    const layerCount = $('[data-layer-count]');
    const zoomLabel = $('[data-zoom-label]');
    const apparelColorControl = $('[data-apparel-color-control]');
    const apparelColorSelect = $('[data-apparel-color-select]');
    const apparelColorChip = $('[data-apparel-color-chip]');
    const apparelColorLabel = $('[data-apparel-color-label]');
    const genericColorControl = $('[data-generic-color-control]');
    const apparelViewsControl = $('[data-apparel-views]');
    const apparelViewNote = $('[data-apparel-view-note]');

    const canvasColors = $('[data-canvas-colors]');
    if(canvasColors){
      canvasColors.append(apparelColorControl.closest('.hgds__field'),colorInput.closest('.hgds__field'));
    }

    const projectMap = {
      apparel:{title:'T-Shirt / Apparel',help:'Keep artwork inside the recommended front decoration area.'},
      hat:{title:'Hat / Cap',help:'Use the green guide as the recommended front decoration area.'},
      'yard-sign':{title:'Yard Sign — 24″ × 18″',help:'24″ wide × 18″ high. Keep important copy inside the safe area.'},
      banner:{title:'Banner / Sign',help:'Keep key copy away from the edge and grommet zone.'},
      decal:{title:'Vinyl / Decal',help:'Use the green guide as the finished decal safe area.'}
    };

    const shirtImages = {"Apple Green":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/N6210-Next-Level-Adult-CVC-Tee-Apple-Green.jpg?v=1789996601","Banana Cream":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Banana_Cream_Front_High_065cfbec-3923-42d9-b4f8-8819deeb5801.jpg?v=1789998573","Black":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Black_Front_High_1030474c-c424-4fb3-af4b-07baa32c80cd.jpg?v=1789998573","Bondi Blue":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Bondi_Blue_Front_High_9f1ec422-1037-485f-b79b-2826d6e6d58c.jpg?v=1789998573","Cardinal":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Cardinal_Front_High_54871179-bec0-4c62-a51e-ea3c91f23e3b.jpg?v=1789998573","Charcoal":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Charcoal_Front_High_d24f3450-fdff-4159-8b33-71ce2eb8006e.jpg?v=1789998573","Cream":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Cream_Front_High_ae8dca21-cd36-425a-b9a7-372137209aa6.jpg?v=1789998574","Dark Heather Gray":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Dark_Heather_Grey_Front_High_e7d2a843-43f4-4879-ace2-7dfdedc95338.jpg?v=1789998574","Espresso":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Espresso_Front_High_255775e6-82ec-42e4-b2c1-1c971a14152c.jpg?v=1789998573","Heather Columbia Blue":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Columbia_Blue_Front_High_5fc175b8-dd59-48b0-9f13-4f7114c22191.jpg?v=1789998574","Heather Cool Blue":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Cool_Blue_Front_High_3d930479-a935-4535-8b12-1b2159baf5a3.jpg?v=1789998574","Heather Forest Green":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Forest_Green_Front_High_86c17d8b-17cb-4e00-a17e-5dfcef19cb02.jpg?v=1789998574","Heather Heavy Metal":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Heavy_Metal_Front_High_cd98bde0-92eb-4559-8de6-a24b7c4d78cf.jpg?v=1789998573","Heather Light Pink":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Light_Pink_Front_High_566e735d-bdfa-48f8-b0f8-e5ba5e65e4ee.jpg?v=1789998573","Heather Maroon":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Maroon_Front_High_fa6d34e0-fc3c-434e-a9d3-f3d7c87ee56d.jpg?v=1789998574","Heather Mauve":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Mauve_Front_High_0f856187-e11d-4acf-8a82-10b3309e06d3.jpg?v=1789998574","Heather Redwood":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Redwood_Front_High_47a7d737-063e-4ae9-a898-f335e3a9ab23.jpg?v=1789998573","Heather Seafoam":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/N6210-Heather-Seafoam.jpg?v=1789998497","Heather Shiitake":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/N6210-Heather-Shiitake.jpg?v=1789998488","Heather Slate Blue":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Slate_Blue_Front_High_da5645dc-6969-45cb-bfc2-f52c745f0bb6.jpg?v=1789998574","Heather Tan":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Heather_Tan_Front_High_8561815f-0ea9-459c-b4bc-e53eb20ffb2d.jpg?v=1789998573","Ice Blue":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Ice_Blue_Front_High_f4e92607-8fdc-4150-b075-9c06bd90197d.jpg?v=1789998573","Indigo":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Indigo_Front_High_c2da6c0d-e731-4a25-8635-c2c0ad636e5d.jpg?v=1789998574","Kelly Green":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Kelly_Green_Front_High_56f79e07-9774-4db9-8ad8-b680bd8754b3.jpg?v=1789998574","Light Olive":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Light_Olive_Front_High_f4f4298d-4df0-4c82-87e3-1cefb0b9766a.jpg?v=1789998573","Midnight Navy":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Midnight_Navy_Front_High_eb0050dd-0d7f-421b-92ed-a62be3ad4a94.jpg?v=1789998573","Military Green":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Military_Green_Front_High_31d87a15-b2e5-49ea-bd2b-5d8698689627.jpg?v=1789998573","Mint":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Mint_Front_High_2c3a0827-3647-4e06-97ce-4d965c84d91d.jpg?v=1789998573","Neon Green":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/N6210-Neon-Green.jpg?v=1789998504","Neon Yellow":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Neon_Yellow_Front_High_4643a600-95c0-46dc-a5c8-1517fe011d7b.jpg?v=1789998573","Orange":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Orange_Front_High_145a4ca1-b191-4f29-80f7-a8e1ca9cc4df.jpg?v=1789998573","Purple Rush":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Purple_Rush_Front_High_ea607a7f-c4fd-4210-8d61-ce525b4e1532.jpg?v=1789998574","Red":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Red_Front_High_a9befc36-9440-48ff-970c-140ce206b97f.jpg?v=1789998573","Royal":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Royal_Front_High_e6cf375e-c265-4aee-818f-226f8a2a0c4a.jpg?v=1789998574","Sand":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Sand_Front_High_af5564fd-6b94-4a18-87ba-55697acafb8a.jpg?v=1789998574","Silk":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Silk_Front_High_d0f03ef7-bc69-4fa3-b48c-1cc369c1b7ee.jpg?v=1789998574","Stone Gray":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Stone_Grey_Front_High_3579ee61-7d8a-42d6-a63a-70096e1d6705.jpg?v=1789998573","Storm":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/N6210-Storm.jpg?v=1789998511","Tahiti Blue":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Tahiti_Blue_Front_High_a2e562d7-76d8-4ccb-bc94-8b7d1cb6c3f7.jpg?v=1789998573","Teal":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Teal_Front_High_1c6bdc52-fc93-41b3-8cd8-eb1034311fa5.jpg?v=1789998574","Turquoise":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Turquoise_Front_High_771d3e05-df5b-4882-935a-ed7a30832201.jpg?v=1789998573","Warm Gray":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_Warm_Grey_Front_High_a0531b03-da26-4e50-b1e5-ac59ebe1d251.jpg?v=1789998574","White":"https://cdn.shopify.com/s/files/1/0569/6225/2878/files/Next_Level_6210_White_Front_High_ce712abf-f64a-4635-b062-7bc389d5be58.jpg?v=1789998574"};
    const shirtHex = {"Apple Green":"#74a64a","Banana Cream":"#f2e3a2","Black":"#111111","Bondi Blue":"#40a8b8","Cardinal":"#8d2431","Charcoal":"#4c4f52","Cream":"#efe1c6","Dark Heather Gray":"#55585b","Espresso":"#4b342b","Heather Columbia Blue":"#7fa9c7","Heather Cool Blue":"#7f9fb1","Heather Forest Green":"#476951","Heather Heavy Metal":"#5f6264","Heather Light Pink":"#e5b9c4","Heather Maroon":"#744450","Heather Mauve":"#a76f7c","Heather Redwood":"#9a5f55","Heather Seafoam":"#9cc6b8","Heather Shiitake":"#8d8174","Heather Slate Blue":"#637f95","Heather Tan":"#a99278","Ice Blue":"#b8d8df","Indigo":"#445a79","Kelly Green":"#178447","Light Olive":"#8a9161","Midnight Navy":"#202f47","Military Green":"#596044","Mint":"#a6d1bd","Neon Green":"#7bcf44","Neon Yellow":"#d8e943","Orange":"#e86d2a","Purple Rush":"#6f4b89","Red":"#c83436","Royal":"#3157a5","Sand":"#c5b28e","Silk":"#d6b0a0","Stone Gray":"#8f9190","Storm":"#68757a","Tahiti Blue":"#3da3b5","Teal":"#2b7777","Turquoise":"#3ab6bc","Warm Gray":"#9b9187","White":"#ffffff"};
    const sanmarBackSketch = 'https://cdnp.sanmar.com/medias/?context=bWFzdGVyfGltYWdlc3w1NzcxODh8aW1hZ2UvanBlZ3xhR0UyTDJnMk5DOHlPRGt4TURVMU1EY3hNak0xTUF8OTI2MDJmNWY4MmE1ZTc5YzZiZjA0YWE2ODlhZGI5M2Q2YWIyNWM2OWU1ZmQ1YWE3YjczMzk5NjY2YWJhNDdiNw';

    const hatImages = {
      '#ffffff':'https://cdn.shopify.com/s/files/1/0569/6225/2878/files/upload-1790717105937.jpg?v=1790717107',
      '#111111':'https://cdn.shopify.com/s/files/1/0569/6225/2878/files/upload-1790717078881.jpg?v=1790717080',
      '#24334a':'https://cdn.shopify.com/s/files/1/0569/6225/2878/files/upload-1790717098812.jpg?v=1790717100',
      '#8b1f2d':'https://cdn.shopify.com/s/files/1/0569/6225/2878/files/upload-1790717085504.jpg?v=1790717087',
      '#315c3a':'https://cdn.shopify.com/s/files/1/0569/6225/2878/files/upload-1790717071720.jpg?v=1790717073',
      '#d9d9d7':'https://cdn.shopify.com/s/files/1/0569/6225/2878/files/upload-1790717092170.jpg?v=1790717093'
    };

    const hatPanel = $('[data-hat-order]');
    let hatCatalog = [], hatProduct = null, hatColor = '', hatView = 'front', hatRows = [];
    let hatViewStates = {front:[],back:[],left:[],right:[]};
    let hatRequest = 0, hatBusy = false, hatStep = 1, hatUploadPending = 0;
    const hatStrings = JSON.parse($('[data-hat-checkout-strings]').textContent);
    hatStrings.steps=hatStrings.steps.map(text=>new DOMParser().parseFromString(text,'text/html').body.textContent);
    const hatCatalogReady = fetch(root.dataset.hatImages).then(r=>{if(!r.ok)throw new Error('Hat images');return r.json();}).then(data=>{hatCatalog=data;return data;});
    const hatStyle = () => hatCatalog.find(p=>p.style===$('[data-hat-style]')?.value);
    function hatImagesForColor(){
      const colors=hatStyle()?.colors||{};
      const key=Object.keys(colors).find(c=>colorKey(c)===colorKey(hatColor));
      return colors[key]||null;
    }
    function hatImageUrl(){
      const file=hatImagesForColor()?.[hatView];
      return file?new URL(file,new URL(root.dataset.hatImages,location.href)).href:null;
    }
    const isFivePanelHat = () => ['258','355','112FPC'].includes(hatStyle()?.style);
    function syncHatDecoration(){
      const enabled=!!hatStyle(),method=$('[data-hat-decoration]');
      method.options[0].textContent=isFivePanelHat()?'DTF':'DTF (single panel only)';
      $('[data-hat-panel-options]').hidden=isFivePanelHat()||method.value!=='DTF';
      $('[data-hat-decoration-note]').textContent=isFivePanelHat()?'Front DTF and embroidery: maximum height 2.25 inches. Five-panel hats are best for DTF: one continuous front panel with no center seam.':'Front DTF and embroidery: maximum height 2.25 inches. For DTF, choose the left or right front panel in the preview. Artwork must stay within that panel and cannot cross seams.';
      $('[data-hat-decoration-options]').hidden=!enabled;
      $('[data-hat-digitizing-options]').hidden=!enabled||method.value!=='Embroidery';
      const digitizingNote=$('[data-hat-digitizing-options]').querySelector('p');
      if(digitizingNote)digitizingNote.textContent='Embroidery adds $8.50 per hat. Hat digitizing is a one-time $20 charge per design when needed. Reuse your existing digitized hat design without another digitizing charge; provide the embroidery file with your artwork link.';
      if(!enabled||method.value!=='Embroidery')$('[data-hat-digitizing]').checked=false;
      updateHatSummary();if(currentProject==='hat')draw();
    }
    function hatQuoteData(){
      const rows=hatRows.map(r=>({variantId:r.variant.id,size:r.size,quantity:Number(r.input.value)||0,price:r.variant.price})).filter(r=>r.quantity>0);
      const views={...hatViewStates,[hatView]:snapshot()};
      const quantity=rows.reduce((n,r)=>n+r.quantity,0),subtotal=rows.reduce((n,r)=>n+r.quantity*r.price,0);
      const decoration=hatStyle()?$('[data-hat-decoration]').value:null;
      const dtfSinglePanel=!isFivePanelHat()&&decoration==='DTF';
      const frontPanel=dtfSinglePanel?$('[data-hat-front-panel]').value:null;
      const embroideryPerHat=decoration==='Embroidery'?850:0,embroideryTotal=quantity*embroideryPerHat;
      const digitizingNeeded=decoration==='Embroidery'&&$('[data-hat-digitizing]').checked;
      const digitizingFee=quantity>0&&digitizingNeeded?2000:0;
      return {brand:'Richardson',style:hatStyle()?.style,handle:hatProduct?.handle,color:hatColor,rows,quantity,subtotal,decoration,dtfSinglePanel,frontPanel,maxFrontDecorationHeightInches:2.25,digitizingOneTimePerDesign:true,embroideryPerHat,embroideryTotal,digitizingNeeded,digitizingFee,total:subtotal+embroideryTotal+digitizingFee,locations:Object.keys(views).filter(k=>views[k].length)};
    }
    function updateHatSummary(){
      if(!hatPanel)return;
      const d=hatQuoteData();$('[data-hat-cart]').disabled=hatBusy;const review=$('[data-hat-review]');if(review)review.textContent='Richardson '+(d.style||'')+' · '+(d.color||'')+' · '+(d.decoration||'')+' · '+(d.digitizingNeeded?'Digitizing included':'No digitizing');$('[data-hat-total]').textContent=money(d.total);
      $('[data-hat-base-total]').textContent=money(d.subtotal);
      $('[data-hat-embroidery-total]').textContent=money(d.embroideryTotal);
      $('[data-hat-digitizing-total]').textContent=money(d.digitizingFee);
      $('[data-hat-status]').textContent=d.quantity?d.quantity+' hat'+(d.quantity===1?'':'s')+' · '+(d.locations.join(', ')||'Add artwork to a view'):'Choose quantities to see your total.';
      if(currentProject==='hat'){const qty=$('#hgds-qty');if(qty){qty.value=d.quantity||'';qty.readOnly=true;}}
    }
    function hatCrop(image){
      if(image.hgHatCrop)return image.hgHatCrop;
      try{
        const canvas=document.createElement('canvas'),scale=Math.min(1,400/image.width);
        canvas.width=Math.round(image.width*scale);canvas.height=Math.round(image.height*scale);
        const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(image,0,0,canvas.width,canvas.height);
        const pixels=ctx.getImageData(0,0,canvas.width,canvas.height).data;
        let minX=canvas.width,minY=canvas.height,maxX=0,maxY=0;
        for(let y=0;y<canvas.height;y+=2)for(let x=0;x<canvas.width;x+=2){const i=(y*canvas.width+x)*4;if(pixels[i+3]>50&&Math.min(pixels[i],pixels[i+1],pixels[i+2])<230){minX=Math.min(minX,x);minY=Math.min(minY,y);maxX=Math.max(maxX,x);maxY=Math.max(maxY,y);}}
        if(maxX>minX&&maxY>minY){const pad=12;const x=Math.max(0,minX-pad)/scale,y=Math.max(0,minY-pad)/scale;image.hgHatCrop={x,y,width:Math.min(image.width-x,(maxX-minX+2*pad)/scale),height:Math.min(image.height-y,(maxY-minY+2*pad)/scale)};}
      }catch(e){}
      return image.hgHatCrop||{x:0,y:0,width:image.width,height:image.height};
    }
    async function loadHatStyle(){
      const request=++hatRequest;hatBusy=true;updateHatSummary();$('[data-hat-status]').textContent='Loading hat colors…';
      try{
        const cfg=hatStyle(),route=window.Shopify?.routes?.root||'/';
        const response=await fetch(route+'products/'+encodeURIComponent(cfg.handle)+'.js',{credentials:'same-origin',cache:'no-store'});
        if(!response.ok)throw new Error('Hat options are unavailable.');
        const data=await response.json();if(request!==hatRequest)return;
        hatProduct=data;const select=$('[data-hat-color]');select.replaceChildren();
        const index=data.options.findIndex(o=>/colou?r/i.test(typeof o==='string'?o:o.name));
        const colors=[...new Set(data.variants.map(v=>v.options[index]))].filter(c=>Object.keys(cfg.colors).some(k=>colorKey(k)===colorKey(c)));
        colors.sort((a,b)=>a.localeCompare(b)).forEach(c=>select.append(new Option(c,c)));
        if(!colors.length)throw new Error('No matching catalog colors are available.');
        hatColor=colors.includes(hatColor)?hatColor:(colors.find(c=>c==='Black')||colors[0]);select.value=hatColor;
        await setHatView('front');hatBusy=false;loadHatSizes();syncHatDecoration();
        const thumb=$('[data-project="hat"] img');if(thumb){thumb.src=hatImageUrl();thumb.alt='Richardson '+cfg.style+' '+hatColor+' front';}
      }catch(e){if(request===hatRequest){hatBusy=false;hatProduct=null;hatRows=[];$('[data-hat-cart]').disabled=false;$('[data-hat-sizes]').replaceChildren();$('[data-hat-status]').textContent=e.message;}}
    }
    function loadHatSizes(){
      if(!hatProduct)return;
      $$('[data-hat-view]').forEach(b=>{b.disabled=!hatImagesForColor()?.[b.dataset.hatView];b.title=b.disabled?'Photo unavailable for this color':'';});
      if(!hatImagesForColor()?.[hatView])setHatView('front');
      const index=hatProduct.options.findIndex(o=>/colou?r/i.test(typeof o==='string'?o:o.name));
      const sizeIndex=hatProduct.options.findIndex(o=>/size/i.test(typeof o==='string'?o:o.name));
      const prior=new Map(hatRows.map(r=>[r.size,r.input.value]));hatRows=[];
      const list=$('[data-hat-sizes]');list.replaceChildren();
      hatProduct.variants.filter(v=>v.options[index]===hatColor).forEach((variant,i)=>{
        const size=sizeIndex<0?'Adjustable':variant.options[sizeIndex],row=document.createElement('div');row.className='hgds__size-row';
        const label=document.createElement('label'),price=document.createElement('span'),input=document.createElement('input');
        input.id='hgds-hat-quantity-'+i;input.type='number';input.min='0';input.max='10000';input.step='1';input.value=prior.get(size)||'0';input.disabled=!variant.available;
        if(input.disabled)input.value='0';label.htmlFor=input.id;label.textContent=size==='OSFA'?'One size':size;price.textContent=money(variant.price);
        input.setAttribute('aria-label',label.textContent+' hat quantity');input.addEventListener('input',()=>{if(!Number.isInteger(Number(input.value))||Number(input.value)<0)input.value='0';updateHatSummary();});
        row.append(label,price,input);list.append(row);hatRows.push({size,variant,input});
      });
      updateHatSummary();if(currentProject==='hat')draw();
    }
    async function setHatView(view){
      if(currentProject==='hat')hatViewStates[hatView]=snapshot();
      hatView=view;$$('[data-hat-view]').forEach(b=>{b.classList.toggle('is-active',b.dataset.hatView===view);b.setAttribute('aria-pressed',String(b.dataset.hatView===view));});
      $('[data-hat-view-note]').textContent=({front:'Front',back:'Rear',left:'Left side',right:'Right side'})[view]+' decoration area';
      if(currentProject==='hat')helpEl.textContent='Use the green guide for '+({front:'front',back:'rear',left:'left side',right:'right side'})[view]+' decoration.';
      if(currentProject==='hat'){const selectedId=selected?.getAttr('hgLayerId');history=[];historyIndex=-1;await restore(hatViewStates[view]);const previous=designNodes().find(n=>n.getAttr('hgLayerId')===selectedId);if(previous)selectNode(previous);draw();saveHistory();renderLayers();}
    }
    function downloadHatDesign(){
      const blob=new Blob([JSON.stringify({version:1,order:hatQuoteData(),views:{...hatViewStates,[hatView]:snapshot()},canvas:{width:stage.width(),height:stage.height()}},null,2)],{type:'application/json'});
      const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='HG-hat-all-views-design.json';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
    }
    function initializeHatOrder(){
      if(!hatPanel)return;
      hatCatalogReady.then(()=>{const select=$('[data-hat-style]');hatCatalog.forEach(c=>select.append(new Option(c.style+' · '+c.brand,c.style)));select.value='112';loadHatStyle();}).catch(()=>{$('[data-hat-status]').textContent='Hat options could not load. Please refresh or contact HG.';});
      $('[data-hat-style]').addEventListener('change',loadHatStyle);
      $('[data-hat-decoration]').addEventListener('change',syncHatDecoration);
      $('[data-hat-front-panel]').addEventListener('change',()=>{updateHatSummary();if(currentProject==='hat')draw();});
      $('[data-hat-digitizing]').addEventListener('change',updateHatSummary);
      $('[data-hat-color]').addEventListener('change',()=>{hatColor=$('[data-hat-color]').value;loadHatSizes();});
      $$('[data-hat-view]').forEach(b=>b.addEventListener('click',()=>setHatView(b.dataset.hatView)));
      $('[data-hat-download]').addEventListener('click',downloadHatDesign);
      $('[data-hat-cart]').addEventListener('click',addHatsToCart);
      initializeHatSteps();
      $('[data-hat-quote]').addEventListener('click',()=>{fillQuote();root.dataset.hatQuote='true';form?.scrollIntoView({behavior:'smooth',block:'start'});});
    }

    function hatError(message){
      const status=$('[data-hat-flow-status]');status.textContent=message;status.focus();
    }
    function setHatStep(step){
      hatStep=step;root.dataset.hatStep=String(step);root.dataset.hatQuote='false';
      if(hatLayout&&currentProject==='hat'){
        const target=step===1?hatLayout.settings.querySelector('details'):step===2?hatLayout.art.details:step===3?hatLayout.settings.querySelectorAll('details')[1]:hatLayout.summary;
        if(target){if(target.tagName==='DETAILS'){
          target.open=true;
          const groups=[...hatLayout.settings.querySelectorAll('details')];
          groups.forEach(g=>g.classList.toggle('is-mobile-active',g===target));
          const mobileIndex=step===1?0:step===2?1:2;
          [...hatLayout.settings.querySelectorAll('.hgds__hat-mobile-tabs button')].forEach((b,i)=>b.setAttribute('aria-selected',String(i===mobileIndex)));
        }target.scrollIntoView({block:'nearest'});} 
      }
      const stepTitle=$('[data-hat-step-title]');if(!stepTitle)return;
      stepTitle.textContent=hatStrings.steps[step-1];$('[data-hat-step-hint]').textContent=hatStrings.hints[step-1];
      $$('[data-hat-step]').forEach(b=>{b.setAttribute('aria-current',Number(b.dataset.hatStep)===step?'step':'false');});
      $('[data-hat-flow-back]').disabled=step===1;$('[data-hat-flow-next]').hidden=step===4;
      $('[data-hat-flow-status]').textContent='';
      requestAnimationFrame(()=>{if(currentProject==='hat')resize();});
    }
    function initializeHatSteps(){
      const flow=document.createElement('section');flow.className='hgds__hat-flow';flow.setAttribute('aria-label','Hat order steps');
      const nav=document.createElement('nav');nav.className='hgds__hat-steps';
      hatStrings.steps.forEach((label,i)=>{const button=document.createElement('button');button.type='button';button.dataset.hatStep=i+1;button.textContent=(i+1)+'. '+label;button.addEventListener('click',()=>setHatStep(i+1));nav.append(button);});
      const heading=document.createElement('h2');heading.dataset.hatStepTitle='';heading.tabIndex=-1;
      const hint=document.createElement('p');hint.dataset.hatStepHint='';
      const status=document.createElement('p');status.dataset.hatFlowStatus='';status.setAttribute('role','alert');status.tabIndex=-1;
      flow.append(nav,heading,hint,status);$('.hgds__toolbar').before(flow);
      const actions=document.createElement('div');actions.className='hgds__hat-flow-actions';
      const back=document.createElement('button');back.type='button';back.dataset.hatFlowBack='';back.className='hgds__tool';back.textContent=hatStrings.back;back.onclick=()=>{setHatStep(Math.max(1,hatStep-1));heading.focus();};
      const next=document.createElement('button');next.type='button';next.dataset.hatFlowNext='';next.className='hgds__tool hgds__tool--primary';next.textContent=hatStrings.next;
      next.onclick=()=>{if(hatBusy||hatUploadPending){hatError('Please wait for your hat or image to finish loading.');return;}if(hatStep===2&&!hatQuoteData().locations.length){hatError('Add text or upload artwork before continuing.');return;}setHatStep(Math.min(4,hatStep+1));heading.focus();};
      actions.append(back,next);$('.hgds__workspace').after(actions);
      const editor=$('.hgds__panel--left');[...editor.children].filter(el=>!el.matches('[data-hat-order],[data-shirt-order],script,style')).forEach(el=>el.dataset.hatEditor='');
      setHatStep(1);
    }
    async function hatDesignFiles(d,group){
      const states={...hatViewStates,[hatView]:snapshot()};
      const full={version:2,order:d,views:states,canvas:{width:stage.width(),height:stage.height()}};
      const files={'Design file':new File([JSON.stringify(full)],'HG-hat-'+group+'.json',{type:'application/json'})};
      transformer.hide();ui.hide();
      try{files['Design preview']=new File([await (await fetch(stage.toDataURL({pixelRatio:1}))).blob()],'HG-hat-preview.png',{type:'image/png'});}finally{ui.show();transformer.show();}
      let i=0;for(const nodes of Object.values(states))for(const n of nodes)if(n.type==='Image'&&n.attrs.sourceData){const blob=await (await fetch(n.attrs.sourceData)).blob();files['Artwork '+(++i)]=new File([blob],n.attrs.sourceName||'artwork.png',{type:blob.type});}
      if(Object.values(files).some(file=>file.size>20*1024*1024))throw new Error('This design is too large to attach. Please use smaller images or request a quote.');
      return files;
    }
    async function addHatsToCart(){
      if(hatBusy||hatUploadPending){hatError('Please wait for your hat or image to finish loading.');return;}
      const d=hatQuoteData();
      if(!d.quantity){hatError('Choose at least one hat.');return;}
      if(d.locations.length!==1||d.locations[0]!=='front'||d.decoration!=='Embroidery'){hatError('Online ordering supports one front embroidery design. Please request a quote for DTF or additional locations.');return;}
      const link=$('#hgds-art-link')?.value.trim()||'';
      if(!d.digitizingNeeded&&!artworkLinkValid(link)){hatError('For an already-digitized design, provide a shareable embroidery-file link in the quote form, or select digitizing.');root.dataset.hatQuote='true';return;}
      const group=crypto.randomUUID(),status=$('[data-hat-status]'),button=$('[data-hat-cart]');hatBusy=true;updateHatSummary();status.textContent=hatStrings.working;
      try{
        const files=await hatDesignFiles(d,group),props={'Design Studio':'HG Hat Studio','Design group':group,'Hat style':d.style,'Hat color':d.color,'Decoration':'Front embroidery','Digitizing':d.digitizingNeeded?'New design — $20 once':'Existing digitized design','Artwork link':link};
        const items=d.rows.map(r=>({id:r.variantId,quantity:r.quantity,properties:{...props,'_hg_hat_role':'hat'}}));
        for(const r of d.rows)items.push({id:40620037570638,quantity:r.quantity,parent_id:r.variantId,properties:{'Design group':group,'Hat style':d.style,'Hat color':d.color,'_hg_hat_role':'embroidery'}});
        if(d.digitizingNeeded)items.push({id:40499803848782,quantity:1,parent_id:d.rows[0].variantId,properties:{'Design group':group,'Hat style':d.style,'_hg_hat_role':'digitizing'}});
        const route=window.Shopify?.routes?.root||'/';
        const body=new FormData();body.append('id',items[0].id);body.append('quantity',items[0].quantity);
        for(const [key,value]of Object.entries(items[0].properties))if(value)body.append('properties['+key+']',value);
        for(const [key,file]of Object.entries(files))body.append('properties['+key+']',file);
        const response=await fetch(route+'cart/add.js',{method:'POST',body,credentials:'same-origin'}),result=await response.json();
        if(!response.ok)throw new Error('Hat: '+(result.description||hatStrings.cart_error));
        if(!/^https?:\/\//.test(result.properties?.['Design file']||''))throw new Error('Your design file was not attached. Please contact HG before checkout.');
        items.slice(1,d.rows.length).forEach(item=>{item.properties={...result.properties,...item.properties};});
        items.slice(d.rows.length).forEach(item=>{delete item.parent_id;});
        const extraResponse=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items.slice(1)}),credentials:'same-origin'}),extra=await extraResponse.json();
        if(!extraResponse.ok)throw new Error('Decoration: '+(extra.description||hatStrings.cart_error));
        location.assign(route+'cart');
       }catch(e){
        try{const route=window.Shopify?.routes?.root||'/',cart=await (await fetch(route+'cart.js',{credentials:'same-origin'})).json();const updates=Object.fromEntries(cart.items.filter(item=>item.properties?.['Design group']===group).map(item=>[item.key,0]));if(Object.keys(updates).length)await fetch(route+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates}),credentials:'same-origin'});}catch(cleanup){e.message+=' Please check your cart before retrying.';}
        hatBusy=false;updateHatSummary();status.textContent=e.message;hatError(e.message);button.disabled=false;
      }
    }

    const uploadedFiles = [];
    const imageCache = {};
    let currentProject = 'apparel';
    let apparelColor = 'Black';
    let catalogImage = null;
    let garmentImages = {};
    const garmentImagesReady=fetch(root.dataset.shirtImages).then(r=>{if(!r.ok)throw new Error('Images');return r.json();}).then(data=>{garmentImages=data;}).catch(()=>{});
    const styleKeys={'8103224574030':'1717','8084488159310':'NL6210','8084628471886':'5000'};
    const colorKey=value=>String(value).toLowerCase().replace(/[^a-z0-9]/g,'').replace(/grey/g,'gray');
    function garmentViewImage(){
      const colors=garmentImages[styleKeys[String(shirtProduct?.id)]]||{};
      const color=Object.keys(colors).find(k=>colorKey(k)===colorKey(apparelColor));
      const filename=colors[color]?.[apparelView==='back'?'back':'front'];
      return filename?new URL(filename,new URL(root.dataset.shirtImages,location.href)).href:null;
    }
    let shirtOrder = null;
    let apparelView = 'front';
    let apparelViewStates = {front:[],back:[],leftSleeve:[],rightSleeve:[]};
    let productColor = '#ffffff';
    let selected = null;
    let zoom = 1;
    let history = [];
    let historyIndex = -1;
    let restoring = false;
    let drawToken = 0;
    let hatFrontBounds = null;

    const stage = new Konva.Stage({container:stageEl,width:900,height:675});
    const bg = new Konva.Layer();
    const design = new Konva.Layer();
    const ui = new Konva.Layer();
    stage.add(bg,design,ui);

    const transformer = new Konva.Transformer({
      rotateEnabled:true,
      keepRatio:true,
      shiftBehavior:'none',
      borderStroke:'#07943a',
      borderStrokeWidth:1.5,
      anchorFill:'#ffffff',
      anchorStroke:'#07943a',
      anchorStrokeWidth:2,
      anchorSize:10,
      enabledAnchors:['top-left','top-right','bottom-left','bottom-right'],
      boundBoxFunc:(oldBox,newBox)=>(newBox.width<10||newBox.height<10?oldBox:newBox)
    });
    ui.add(transformer);
    const aspectLock = $('[data-aspect-lock]');
    aspectLock?.addEventListener('change', () => {
      transformer.keepRatio(aspectLock.checked);
      transformer.enabledAnchors(aspectLock.checked
        ? ['top-left','top-right','bottom-left','bottom-right']
        : ['top-left','top-right','bottom-left','bottom-right','middle-left','middle-right','top-center','bottom-center']);
      ui.batchDraw();
    });

    const loadImage = url => {
      if (imageCache[url]) return Promise.resolve(imageCache[url]);
      return new Promise((resolve,reject)=>{
        const im=new Image();
        im.crossOrigin='anonymous';
        im.onload=()=>{imageCache[url]=im;resolve(im);};
        im.onerror=reject;
        im.src=url;
      });
    };

    const safe = (x,y,w,h) => bg.add(new Konva.Rect({x,y,width:w,height:h,stroke:'#12a34a',strokeWidth:2,dash:[8,7],cornerRadius:4,listening:false}));

    function studioBg(w,h){
      bg.add(new Konva.Rect({x:0,y:0,width:w,height:h,fill:'#f5f7f5',cornerRadius:12,listening:false}));
      bg.add(new Konva.Text({x:18,y:16,text:'HG CONCEPT PREVIEW',fontSize:11,fontStyle:'bold',fill:'#9aa39c',letterSpacing:1.5,listening:false}));
    }

    let photoPixelsPerInch=1;
    async function draw(){
      const token=++drawToken;
      bg.destroyChildren();hatFrontBounds=null;
      const w=stage.width(),h=stage.height(),cx=w/2,cy=h/2;
      studioBg(w,h);

      if(currentProject==='apparel'){
        const url=garmentViewImage();
        if(url){
          try{
            const im=await loadImage(url);
            if(token!==drawToken)return;
            const maxW=w*.64,maxH=h*.80,s=Math.min(maxW/im.width,maxH/im.height);
            const iw=im.width*s,ih=im.height*s,x=(w-iw)/2,y=(h-ih)/2;
            photoPixelsPerInch=iw/36;
            designNodes().forEach(applyPrintSize);syncPrintControls();design.draw();
            bg.add(new Konva.Rect({x:x-10,y:y-10,width:iw+20,height:ih+20,fill:'#fff',cornerRadius:18,shadowColor:'#1d2a21',shadowBlur:30,shadowOpacity:.10,shadowOffsetY:12,listening:false}));
            bg.add(new Konva.Image({x,y,image:im,width:iw,height:ih,listening:false}));
            if(apparelView==='leftSleeve') safe(w*.305,h*.315,w*.10,h*.13);
            else if(apparelView==='rightSleeve') safe(w*.595,h*.315,w*.10,h*.13);
            else if(apparelView==='back') safe(w*.39,h*.25,w*.22,h*.43);
            else safe(w*.39,h*.285,w*.22,h*.405);
            bg.draw();
            return;
          }catch(e){}
        }
        bg.add(new Konva.Text({x:w*.15,y:h*.4,width:w*.7,text:shirtStrings.image_missing||'Photo unavailable for this style, color and view.',align:'center',fontSize:18,fill:'#444'}));
        bg.draw();return;
      }

      if(currentProject==='hat'){
        const url=hatImageUrl();
        try{
          if(!url)throw new Error('No photo');
          const im=await loadImage(url);if(token!==drawToken)return;
          const crop=hatCrop(im),scale=Math.min(w*.78/crop.width,h*.70/crop.height),iw=crop.width*scale,ih=crop.height*scale,x=(w-iw)/2,y=(h-ih)/2;
          const mirror=hatView==='right'&&hatImagesForColor()?.mirrorRight;
          bg.add(new Konva.Image({x:mirror?x+iw:x,y,image:im,width:iw,height:ih,crop,scaleX:mirror?-1:1,listening:false}));
          if(hatView==='front'){
            const single=!isFivePanelHat()&&$('[data-hat-decoration]').value==='DTF';
            const right=$('[data-hat-front-panel]').value==='right';
            hatFrontBounds={x:x+iw*(single?(right?.53:.29):.29),y:y+ih*.20,width:iw*(single?.18:.42),height:ih*.35};
            safe(hatFrontBounds.x,hatFrontBounds.y,hatFrontBounds.width,hatFrontBounds.height);
            bg.add(new Konva.Text({x:hatFrontBounds.x,y:hatFrontBounds.y-20,width:hatFrontBounds.width,text:'Max height 2.25 in',align:'center',fontSize:12,fill:'#07943a',listening:false}));
            constrainHatFront();
          }
          else if(hatView==='back')safe(x+iw*.28,y+ih*.30,iw*.44,ih*.22);
          else {
            const left=hatView==='left';
            bg.add(new Konva.Rect({x:x+iw*(left?.57:.14),y:y+ih*(left?.64:.71),width:iw*.29,height:ih*.11,rotation:left?8:-8,stroke:'#12a34a',strokeWidth:2,dash:[8,7],cornerRadius:4,listening:false}));
          }
          bg.add(new Konva.Text({x:20,y:h-36,width:w-40,text:'Richardson '+hatStyle().style+' · '+hatColor+' · '+({front:'Front',back:'Rear',left:'Left side',right:'Right side'})[hatView],align:'center',fontSize:14,fill:'#39483c',listening:false}));
          bg.draw();return;
        }catch(e){
          if(token!==drawToken)return;
          bg.add(new Konva.Text({x:w*.12,y:h*.4,width:w*.76,text:'Photo unavailable for this hat color and view. Choose another color or view.',align:'center',fontSize:18,fill:'#444'}));bg.draw();return;
        }
      }

      const stroke=productColor==='#111111'?'#2b2f2c':'#aeb6b0';
      if(currentProject==='yard-sign'){
        const rw=Math.min(w*.78,h*.64*24/18),rh=rw*18/24,x=cx-rw/2,y=h*.16;
        bg.add(new Konva.Rect({x,y,width:rw,height:rh,fill:productColor,stroke,strokeWidth:2,cornerRadius:3,shadowColor:'#1d2a21',shadowBlur:28,shadowOpacity:.16,shadowOffsetY:12,listening:false}));
        bg.add(new Konva.Line({points:[cx-rw*.23,y+rh,cx-rw*.23,h*.89],stroke:'#7e8780',strokeWidth:3,listening:false}));
        bg.add(new Konva.Line({points:[cx+rw*.23,y+rh,cx+rw*.23,h*.89],stroke:'#7e8780',strokeWidth:3,listening:false}));
        safe(x+rw*.05,y+rh*.08,rw*.90,rh*.84);
      }else if(currentProject==='banner'){
        const rw=w*.74,rh=h*.48,x=cx-rw/2,y=cy-rh/2;
        bg.add(new Konva.Rect({x,y,width:rw,height:rh,fill:productColor,stroke,strokeWidth:2,cornerRadius:3,shadowColor:'#1d2a21',shadowBlur:28,shadowOpacity:.16,shadowOffsetY:12,listening:false}));
        [[x+18,y+18],[x+rw-18,y+18],[x+18,y+rh-18],[x+rw-18,y+rh-18]].forEach(p=>bg.add(new Konva.Circle({x:p[0],y:p[1],radius:5,fill:'#8e9691',listening:false})));
        safe(x+rw*.045,y+rh*.085,rw*.91,rh*.83);
      }else if(currentProject==='decal'){
        const rw=w*.56,rh=h*.40,x=cx-rw/2,y=cy-rh/2;
        bg.add(new Konva.Rect({x,y,width:rw,height:rh,cornerRadius:26,fill:productColor,stroke,strokeWidth:2,shadowColor:'#1d2a21',shadowBlur:28,shadowOpacity:.16,shadowOffsetY:12,listening:false}));
        safe(x+rw*.055,y+rh*.10,rw*.89,rh*.80);
      }
      bg.draw();
    }

    function resize(){
      const w=Math.max(280,stageEl.clientWidth||900),h=Math.round(w*(currentProject==='hat'?(window.matchMedia('(max-width:820px)').matches?.5:.55):.75));
      stage.width(w);stage.height(h);draw();
    }
    new ResizeObserver(resize).observe(stageEl);

    const designNodes=()=>design.getChildren().filter(n=>n.getAttr('userLayer'));

    const printWidth=$('[data-print-width]'),printHeight=$('[data-print-height]'),printStatus=$('[data-print-status]');
    const printStrings=JSON.parse($('[data-print-strings]').textContent);
    const roundIn=value=>Math.round(value*100)/100;
    function measurePrint(node){
      if(currentProject!=='apparel'||node?.className!=='Image')return;
      node.setAttrs({printWidthIn:roundIn(Math.abs(node.width()*node.scaleX())/photoPixelsPerInch),printHeightIn:roundIn(Math.abs(node.height()*node.scaleY())/photoPixelsPerInch),printUnit:'in'});
    }
    function applyPrintSize(node){
      if(currentProject!=='apparel'||node.className!=='Image')return;
      if(!node.getAttr('printWidthIn'))measurePrint(node);
      node.scaleX(Math.sign(node.scaleX()||1)*node.getAttr('printWidthIn')*photoPixelsPerInch/node.width());
      node.scaleY(Math.sign(node.scaleY()||1)*node.getAttr('printHeightIn')*photoPixelsPerInch/node.height());
    }
    function syncPrintControls(){
      const active=currentProject==='apparel'&&selected?.className==='Image';
      [printWidth,printHeight,...$$('[data-print-preset]')].forEach(input=>input.disabled=!active);
      printStatus.classList.remove('is-low');
      if(!active){printWidth.value='';printHeight.value='';printStatus.textContent=printStrings.select_art;return;}
      if(!selected.getAttr('printWidthIn'))measurePrint(selected);
      const width=selected.getAttr('printWidthIn'),height=selected.getAttr('printHeightIn');
      printWidth.value=width;printHeight.value=height;
      if(selected.getAttr('sourceIsVector')){printStatus.textContent=printStrings.vector_quality;return;}
      const im=selected.image();
      const ppi=Math.floor(Math.min((selected.getAttr('sourcePixelWidth')||im.naturalWidth||im.width)/width,(selected.getAttr('sourcePixelHeight')||im.naturalHeight||im.height)/height));
      selected.setAttr('effectivePpi',ppi);
      printStatus.textContent=ppi+' PPI — '+printStrings[ppi<150?'quality_low':ppi<300?'quality_mid':'quality_good'];
      printStatus.classList.toggle('is-low',ppi<150);
    }
    function changePrintSize(axis,value){
      if(currentProject!=='apparel'||selected?.className!=='Image'||!Number.isFinite(value)||value<.1||value>(axis==='width'?36:54)){syncPrintControls();return;}
      const w=selected.getAttr('printWidthIn'),h=selected.getAttr('printHeightIn');
      const locked=$('[data-aspect-lock]').checked;
      selected.setAttrs({printWidthIn:roundIn(axis==='width'?value:locked?value*w/h:w),printHeightIn:roundIn(axis==='height'?value:locked?value*h/w:h),printUnit:'in'});
      applyPrintSize(selected);syncPrintControls();design.draw();ui.draw();measurePrint(selected);syncPrintControls();saveHistory();
    }
    printWidth.addEventListener('change',()=>changePrintSize('width',Number(printWidth.value)));
    printHeight.addEventListener('change',()=>changePrintSize('height',Number(printHeight.value)));
    $$('[data-print-preset]').forEach(button=>button.addEventListener('click',()=>changePrintSize('width',Number(button.dataset.printPreset))));


    function selectNode(node){
      selected=node||null;syncPrintControls();
      if(currentProject!=='hat'&&node)showCompact(node.className==='Text'?'text':'artwork');
      transformer.nodes(node?[node]:[]);
      ui.draw();
      for(const button of $$('[data-background-action]'))button.disabled=selected?.className!=='Image';
      const isText=selected&&selected.className==='Text';
      if(hatLayout&&currentProject==='hat'){hatLayout.textFields.forEach(n=>n.hidden=!isText);if(node)hatLayout.art.details.open=true;}
      textValue.disabled=!isText;fontSelect.disabled=!isText;colorInput.disabled=!isText;fontSize.disabled=!isText;
      if(isText){textValue.value=selected.text();fontSelect.value=selected.fontFamily();colorInput.value=selected.fill();fontSize.value=selected.fontSize();}else{textValue.value='';}
      renderLayers();
    }

    function wireNode(node){
      node.setAttr('userLayer',true);if(!node.getAttr('hgLayerId'))node.setAttr('hgLayerId',crypto.randomUUID());
      node.draggable(true);
      node.on('click tap',e=>{e.cancelBubble=true;selectNode(node);});
      node.on('dragend transformend',()=>{measurePrint(node);syncPrintControls();saveHistory();renderLayers();});
    }

    function defaultTextColor(){
      if(currentProject!=='hat')return '#111111';
      const panelColor=hatColor.split('/')[0].trim().toLowerCase();
      const light=/white|birch|biscuit|cream|khaki|gold|silver|light|pink|yellow|neon/.test(panelColor);
      const dark=/black|navy|charcoal|brown|cardinal|maroon|royal|forest|dark|red|green|blue|purple/.test(panelColor);
      return dark&&!light?'#ffffff':'#111111';
    }

    function addText(){
      const node=new Konva.Text({x:stage.width()*.37,y:stage.height()*.43,text:'Your Text',fontSize:44,fontFamily:'Arial',fill:defaultTextColor(),fontStyle:'bold',padding:5});
      wireNode(node);design.add(node);selectNode(node);design.draw();saveHistory();
    }

    function addImage(file){
      if(currentProject==='hat'&&file.size>15*1024*1024){hatError('Please upload an image smaller than 15 MB.');return;}
      if(currentProject==='hat')hatUploadPending++;
      const reader=new FileReader();
      reader.onload=e=>{
        const im=new Image();
        im.onload=()=>{
          const maxW=stage.width()*.34,maxH=stage.height()*.34,s=Math.min(maxW/im.width,maxH/im.height,1);
          const node=new Konva.Image({x:stage.width()*.34,y:stage.height()*.33,image:im,width:im.width*s,height:im.height*s});
          node.setAttr('sourceName',file.name);node.setAttr('sourceData',e.target.result);
          node.setAttrs({sourcePixelWidth:im.naturalWidth,sourcePixelHeight:im.naturalHeight,sourceIsVector:file.type==='image/svg+xml'});
          if(currentProject==='apparel'){node.setAttrs({printWidthIn:apparelView==='back'?11:3.5,printHeightIn:roundIn((apparelView==='back'?11:3.5)*im.height/im.width),printUnit:'in'});applyPrintSize(node);}
          wireNode(node);design.add(node);selectNode(node);design.draw();uploadedFiles.push(file.name);if(currentProject==='hat')hatUploadPending=Math.max(0,hatUploadPending-1);saveHistory();renderLayers();
        };
        im.onerror=()=>{hatUploadPending=Math.max(0,hatUploadPending-1);hatError('This image could not be opened. Try a PNG or JPG.');};im.src=e.target.result;
      };
      reader.onerror=()=>{hatUploadPending=Math.max(0,hatUploadPending-1);hatError('This file could not be read. Please try again.');};
      reader.readAsDataURL(file);
    }

    function removeEdgeBackground(pixels,width,height,color,tolerance){
      const seen=new Uint8Array(width*height),queue=new Uint32Array(width*height);let head=0,tail=0,removed=0;
      const enqueue=p=>{if(!seen[p]){seen[p]=1;queue[tail++]=p;}};
      for(let x=0;x<width;x++){enqueue(x);enqueue((height-1)*width+x);}
      for(let y=0;y<height;y++){enqueue(y*width);enqueue(y*width+width-1);}
      while(head<tail){
        const p=queue[head++],i=p*4;
        const match=pixels[i+3]===0||Math.max(Math.abs(pixels[i]-color[0]),Math.abs(pixels[i+1]-color[1]),Math.abs(pixels[i+2]-color[2]))<=tolerance;
        if(!match)continue;
        if(pixels[i+3])removed++;pixels[i+3]=0;
        const x=p%width,y=Math.floor(p/width);
        if(x)enqueue(p-1);if(x<width-1)enqueue(p+1);if(y)enqueue(p-width);if(y<height-1)enqueue(p+width);
      }
      return removed;
    }
    const backgroundStatus=$('[data-background-status]');
    let backgroundBusy=false;
    async function editBackground(restoreOriginal=false){
      const node=selected;
      if(backgroundBusy||node?.className!=='Image')return;
      backgroundBusy=true;
      const strings=JSON.parse($('[data-background-strings]').textContent);
      backgroundStatus.textContent=strings.working;
      try{
        const original=node.getAttr('originalSourceData')||node.getAttr('sourceData');
        let result=original;
        if(!restoreOriginal){
          const image=await loadImage(original),w=image.naturalWidth,h=image.naturalHeight;
          if(w*h>12000000)throw new Error(strings.large);
          const canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;
          const context=canvas.getContext('2d',{willReadFrequently:true});context.drawImage(image,0,0);
          const data=context.getImageData(0,0,w,h),hex=$('[data-background-color]').value;
          const color=[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16));
          const removed=removeEdgeBackground(data.data,w,h,color,Number($('[data-background-tolerance]').value));
          if(!removed){backgroundStatus.textContent=strings.none;return;}
          context.putImageData(data,0,0);result=canvas.toDataURL('image/png');
        }
        const image=await loadImage(result);
        if(!node.getStage())return;
        node.setAttr('originalSourceData',original);node.setAttr('sourceData',result);node.setAttr('backgroundRemoved',!restoreOriginal);
        node.image(image);design.draw();saveHistory();backgroundStatus.textContent=restoreOriginal?strings.restored:strings.done;
      }catch(error){backgroundStatus.textContent=error.message;}
      finally{backgroundBusy=false;}
    }
    $('[data-remove-background]')?.addEventListener('click',()=>editBackground());
    $('[data-restore-background]')?.addEventListener('click',()=>editBackground(true));
    $('[data-download-artwork]')?.addEventListener('click',()=>{
      if(selected?.className!=='Image')return;
      const a=document.createElement('a');a.href=selected.getAttr('sourceData');a.download='HG-edited-artwork.png';
      document.body.appendChild(a);a.click();a.remove();
    });

    function constrainHatFront(){
      if(currentProject!=='hat'||hatView!=='front'||!hatFrontBounds)return;
      const nodes=designNodes();if(!nodes.length)return;
      const rects=nodes.map(n=>n.getClientRect({relativeTo:design}));
      const left=Math.min(...rects.map(r=>r.x)),top=Math.min(...rects.map(r=>r.y));
      const width=Math.max(...rects.map(r=>r.x+r.width))-left,height=Math.max(...rects.map(r=>r.y+r.height))-top;
      if(!width||!height)return;
      const b=hatFrontBounds,scale=Math.min(1,b.width/width,b.height/height);
      const nextX=Math.max(b.x,Math.min(left,b.x+b.width-width*scale)),nextY=Math.max(b.y,Math.min(top,b.y+b.height-height*scale));
      nodes.forEach(n=>{n.position({x:nextX+(n.x()-left)*scale,y:nextY+(n.y()-top)*scale});n.scale({x:n.scaleX()*scale,y:n.scaleY()*scale});});
      transformer.forceUpdate();design.batchDraw();ui.batchDraw();
    }

    function snapshot(){
      constrainHatFront();
      return designNodes().map(n=>({type:n.className,attrs:{...n.getAttrs(),image:undefined,userLayer:true}}));
    }

    async function restore(snap){
      restoring=true;selectNode(null);design.destroyChildren();
      for(const item of snap||[]){
        if(item.type==='Text'){const n=new Konva.Text(item.attrs);wireNode(n);design.add(n);}
        if(item.type==='Image'&&item.attrs.sourceData){
          const im=await new Promise(resolve=>{const x=new Image();x.onload=()=>resolve(x);x.src=item.attrs.sourceData;});
          const n=new Konva.Image({...item.attrs,image:im});wireNode(n);design.add(n);
        }
      }
      design.draw();restoring=false;renderLayers();
    }

    function saveHistory(){
      if(restoring)return;
      history=history.slice(0,historyIndex+1);history.push(snapshot());historyIndex=history.length-1;
      if(currentProject==='apparel') apparelViewStates[apparelView]=snapshot();
      if(currentProject==='hat')hatViewStates[hatView]=snapshot();
      if(history.length>30){history.shift();historyIndex--;}
    }

    function renderLayers(){
      if(shirtOrder) updateShirtSummary();
      if(hatPanel&&currentProject==='hat')updateHatSummary();
      const arr=[...designNodes()].reverse();layerCount.textContent=arr.length;
      if(!arr.length){layersList.innerHTML='<p class="hgds__muted">Upload artwork or add text to begin.</p>';return;}
      layersList.innerHTML='';
      arr.forEach(n=>{
        const row=document.createElement('button');row.type='button';row.className='hgds__layer'+(n===selected?' is-active':'');
        const label=n.className==='Text'?(n.text()||'Text'):(n.getAttr('sourceName')||'Artwork');
        row.innerHTML='<span>'+label.replace(/[<>]/g,'')+'</span><span>'+(n.className==='Text'?'Text':'Image')+'</span>';
        row.setAttribute('aria-pressed',String(n===selected));row.onclick=()=>{selectNode(n);stageEl.focus();};layersList.appendChild(row);
      });
    }

    let hatLayout = null;
    const hatLayoutStrings=JSON.parse($('[data-hat-layout-strings]').textContent);
    function syncHatLayout(active){
      if(!hatLayout){
        const left=$('.hgds__panel--left'),canvas=$('.hgds__canvas-card');
        const moves=[];
        const move=(node,target)=>{
          if(!node)return;
          const marker=document.createComment('hat-layout');
          node.before(marker);moves.push({node,marker,target});target.append(node);
        };
        const group=(title,open)=>{
          const details=document.createElement('details');details.className='hgds__hat-group';details.open=open;
          const summary=document.createElement('summary');summary.textContent=title;details.append(summary);
          const body=document.createElement('div');body.className='hgds__hat-group-body';details.append(body);return {details,body};
        };
        const choose=group(hatLayoutStrings.choose,true),decorate=group(hatLayoutStrings.decoration,true),art=group(hatLayoutStrings.advanced,false);
        const settings=document.createElement('div');settings.className='hgds__hat-settings';settings.hidden=true;
        settings.append(choose.details,decorate.details,art.details);left.prepend(settings);
        const views=document.createElement('div');views.className='hgds__hat-views';views.hidden=true;
        canvas.querySelector('.hgds__canvas-head').after(views);
        const summary=document.createElement('div');summary.className='hgds__hat-summary';summary.hidden=true;canvas.append(summary);
        [...hatPanel.children].slice(0,3).forEach(n=>move(n,choose.body));
        move($('[data-hat-sizes]').closest('.hgds__field'),choose.body);
        move($('[data-hat-decoration-options]'),decorate.body);
        move($('[data-hat-view]').parentElement,views);
        move($('[data-hat-view-note]'),views);
        [...hatPanel.children].forEach(n=>move(n,summary));
        [...left.children].filter(n=>n.matches('.hgds__field,.hgds__layers')&&!n.contains(shirtOrder)).forEach(n=>move(n,art.body));
        move(colorInput.closest('.hgds__field'),art.body);
        const textFields=[textValue,fontSelect,fontSize].map(n=>n.closest('.hgds__field'));
        const toolbar=document.createElement('div');toolbar.className='hgds__hat-canvas-tools';toolbar.hidden=true;
        canvas.querySelector('.hgds__stage-shell').after(toolbar);
        move($('.hgds__toolbar-main'),toolbar);
        const tabs=document.createElement('div');tabs.className='hgds__hat-mobile-tabs';tabs.setAttribute('role','tablist');tabs.setAttribute('aria-label',hatLayoutStrings.settings);
        [choose,art,decorate].forEach((g,i)=>{
          const b=document.createElement('button');b.type='button';b.textContent=[hatLayoutStrings.hat,hatLayoutStrings.artwork,hatLayoutStrings.decorationTab][i];b.setAttribute('role','tab');b.setAttribute('aria-selected',String(i===0));
          b.addEventListener('click',()=>{[choose,art,decorate].forEach(x=>x.details.classList.toggle('is-mobile-active',x===g));[...tabs.children].forEach(x=>x.setAttribute('aria-selected',String(x===b)));g.details.open=true;});
          tabs.append(b);
        });
        choose.details.classList.add('is-mobile-active');settings.prepend(tabs);
        hatLayout={moves,settings,views,summary,toolbar,art,textFields};
      }
      root.classList.toggle('hgds--hat-layout',active);
      for(const m of hatLayout.moves){if(active)m.target.append(m.node);else m.marker.after(m.node);}
      for(const n of [hatLayout.settings,hatLayout.views,hatLayout.summary,hatLayout.toolbar])n.hidden=!active;
      if(active)hatLayout.textFields.forEach(n=>n.hidden=selected?.className!=='Text');else hatLayout.textFields.forEach(n=>n.hidden=false);
      resize();
    }

    function setProject(key){
      if(key===currentProject)return;
      if(designNodes().length&&!confirm('Switching project types will clear the current design. Continue?'))return;
      currentProject=key;root.dataset.projectType=key;design.destroyChildren();selectNode(null);
      const dimensions=$('#hgds-dimensions');
      if(dimensions){if(key==='yard-sign')dimensions.value='24" × 18"';else if(dimensions.value==='24" × 18"')dimensions.value='';}
      if(dimensions)dimensions.placeholder=key==='hat'?'e.g. 2\" wide × 1.5\" high (artwork)':'e.g. 24\" × 18\"';
      $$('[data-project]').forEach(b=>b.classList.toggle('is-active',b.dataset.project===key));
      const cfg=projectMap[key];titleEl.textContent=cfg.title;helpEl.textContent=cfg.help;projectHidden.value=cfg.title;
      apparelColorControl.hidden=key!=='apparel';
      apparelColorControl.closest('.hgds__field').hidden=key==='hat';
      apparelViewsControl.hidden=key!=='apparel';
      if(shirtOrder) shirtOrder.hidden=key!=='apparel';
      genericColorControl.hidden=key==='apparel'||key==='hat';
      if(hatPanel)hatPanel.hidden=key!=='hat';
      syncHatLayout(key==='hat');
      if(key==='hat'){setHatStep(1);hatView='front';hatViewStates={front:[],back:[],left:[],right:[]};setHatView('front');loadHatSizes();}
      const qty=$('#hgds-qty');if(qty)qty.readOnly=key==='apparel'||key==='hat';
      if(key!=='apparel'){apparelView='front';apparelViewStates={front:[],back:[],leftSleeve:[],rightSleeve:[]};}
      syncCompactProject();draw();saveHistory();renderLayers();
    }

    function downloadPreview(){
      constrainHatFront();
      selectNode(null);
      const a=document.createElement('a');a.download='HG-'+currentProject+'-design-preview.png';a.href=stage.toDataURL({pixelRatio:2});
      document.body.appendChild(a);a.click();a.remove();
    }

    function fillQuote(){
      if(currentProject==='apparel') apparelViewStates[apparelView]=snapshot();
      if(currentProject==='hat')hatViewStates[hatView]=snapshot();
      const compactStored = snap => (snap||[]).map((item,i)=>({
        order:i+1,type:item.type,text:item.type==='Text'?item.attrs.text:undefined,
        filename:item.type==='Image'?item.attrs.sourceName:undefined,printWidthIn:item.attrs.printWidthIn,printHeightIn:item.attrs.printHeightIn,effectivePpi:item.attrs.effectivePpi,
        x:Math.round(item.attrs.x||0),y:Math.round(item.attrs.y||0),rotation:Math.round(item.attrs.rotation||0)
      }));
      designHidden.value=JSON.stringify({
        project:projectMap[currentProject].title,
        shirtOrder:currentProject==='apparel'?shirtQuoteData():undefined,
        hatOrder:currentProject==='hat'?hatQuoteData():undefined,
        hatViews:currentProject==='hat'?Object.fromEntries(Object.entries(hatViewStates).map(([k,v])=>[k,compactStored(v)])):undefined,
        productColor:currentProject==='hat'?hatColor:currentProject==='apparel'?apparelColor:productColor,
        apparelViews:currentProject==='apparel'?{
          front:compactStored(apparelViewStates.front),
          back:compactStored(apparelViewStates.back),
          leftSleeve:compactStored(apparelViewStates.leftSleeve),
          rightSleeve:compactStored(apparelViewStates.rightSleeve)
        }:undefined,
        layers:currentProject==='apparel'?undefined:designNodes().map((n,i)=>({order:i+1,type:n.className,text:n.className==='Text'?n.text():undefined,filename:n.className==='Image'?n.getAttr('sourceName'):undefined,x:Math.round(n.x()),y:Math.round(n.y()),rotation:Math.round(n.rotation())}))
      });
      filesHidden.value=[...new Set(uploadedFiles)].join(', ')||'None uploaded in studio';
      projectHidden.value=projectMap[currentProject].title;
    }

    stage.on('click tap',e=>{if(e.target===stage||e.target.getLayer()===bg)selectNode(null);});
    $$('[data-project]').forEach(b=>b.onclick=()=>setProject(b.dataset.project));
    $('[data-add-text]').onclick=addText;
    $('[data-upload-trigger]').onclick=()=>$('[data-upload]').click();
    stageEl.addEventListener('keydown',e=>{
      if(!selected)return;
      const step=e.shiftKey?10:1;let changed=true;
      if(e.key==='ArrowLeft')selected.x(selected.x()-step);
      else if(e.key==='ArrowRight')selected.x(selected.x()+step);
      else if(e.key==='ArrowUp')selected.y(selected.y()-step);
      else if(e.key==='ArrowDown')selected.y(selected.y()+step);
      else if(e.key==='+'||e.key==='='){selected.scaleX(selected.scaleX()*1.05);selected.scaleY(selected.scaleY()*1.05);}
      else if(e.key==='-'){selected.scaleX(selected.scaleX()/1.05);selected.scaleY(selected.scaleY()/1.05);}
      else if(e.key==='[')selected.rotation(selected.rotation()-step);
      else if(e.key===']')selected.rotation(selected.rotation()+step);
      else changed=false;
      if(changed){e.preventDefault();design.draw();ui.draw();measurePrint(selected);syncPrintControls();saveHistory();}
    });
    $('[data-upload]').onchange=e=>{[...e.target.files].slice(0,5).forEach(addImage);e.target.value='';};
    $('[data-delete]').onclick=()=>{if(selected){selected.destroy();selectNode(null);design.draw();saveHistory();renderLayers();}};
    $('[data-reset]').onclick=()=>{if(!designNodes().length||confirm('Clear the current design?')){design.destroyChildren();selectNode(null);design.draw();saveHistory();renderLayers();}};
    $('[data-download]').onclick=downloadPreview;
    $('[data-undo]').onclick=async()=>{if(historyIndex>0){historyIndex--;await restore(history[historyIndex]);}};
    $('[data-redo]').onclick=async()=>{if(historyIndex<history.length-1){historyIndex++;await restore(history[historyIndex]);}};
    $('[data-zoom-in]').onclick=()=>{zoom=Math.min(1.5,zoom+.1);design.scale({x:zoom,y:zoom});design.draw();zoomLabel.textContent=Math.round(zoom*100)+'%';};
    $('[data-zoom-out]').onclick=()=>{zoom=Math.max(.6,zoom-.1);design.scale({x:zoom,y:zoom});design.draw();zoomLabel.textContent=Math.round(zoom*100)+'%';};

    apparelColorSelect?.addEventListener('change',()=>{
      apparelColor=apparelColorSelect.value;
      apparelColorLabel.textContent=apparelColor;
      apparelColorChip.style.setProperty('--shirt-color',shirtHex[apparelColor]||'#cccccc');
      draw();
      loadShirtSizes();
    });

    $$('[data-apparel-view]').forEach(b=>b.addEventListener('click',async()=>{
      if(currentProject!=='apparel')return;
      if(b.dataset.apparelView===apparelView)return;
      apparelViewStates[apparelView]=snapshot();
      apparelView=b.dataset.apparelView;
      $$('[data-apparel-view]').forEach(x=>x.classList.toggle('is-active',x===b));
      const notes={front:'Front decoration area',back:'Back decoration area',leftSleeve:'Left sleeve decoration area',rightSleeve:'Right sleeve decoration area'};
      apparelViewNote.textContent=notes[apparelView];
      helpEl.textContent=notes[apparelView]+' — artwork is saved separately for this location.';
      history=[];historyIndex=-1;
      await restore(apparelViewStates[apparelView]||[]);
      draw();saveHistory();renderLayers();
    }));

    $$('[data-product-swatch]').forEach(b=>b.onclick=()=>{
      productColor=b.dataset.productSwatch;
      $$('[data-product-swatch]').forEach(x=>x.classList.toggle('is-active',x===b));
      draw();
    });
    $$('[data-swatch]').forEach(b=>b.onclick=()=>{colorInput.value=b.dataset.swatch;colorInput.dispatchEvent(new Event('input'));});

    textValue.oninput=()=>{if(selected?.className==='Text'){selected.text(textValue.value);design.draw();renderLayers();}};
    textValue.onchange=saveHistory;
    fontSelect.onchange=()=>{if(selected?.className==='Text'){selected.fontFamily(fontSelect.value);design.draw();saveHistory();}};
    colorInput.oninput=()=>{if(selected?.className==='Text'){selected.fill(colorInput.value);design.draw();}};
    colorInput.onchange=saveHistory;
    fontSize.oninput=()=>{if(selected?.className==='Text'){selected.fontSize(+fontSize.value);design.draw();}};
    fontSize.onchange=saveHistory;

    $('[data-save-draft]')?.addEventListener('click',()=>{
      fillQuote();
      try { localStorage.setItem('hgDesignStudioDraft',JSON.stringify({project:currentProject,productColor,apparelColor,shirtOrder:shirtQuoteData(),views:apparelViewStates,hatOrder:hatQuoteData(),hatViews:hatViewStates,layers:snapshot()})); } catch(e) { downloadShirtDesign(); }
      alert('Design draft saved in this browser.');
    });
    form?.addEventListener('submit',()=>{fillQuote();downloadPreview();});

    let shirtProduct=null, shirtRows=[], shirtRequest=0, shirtBusy=false, shirtStrings={};
    const shirtCache=new Map();
    const tiers=[[1,0],[5,300],[25,500],[50,700],[100,1000],[200,1200]];
    const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);
    const discountFor=q=>tiers.reduce((amount,t)=>q>=t[0]?t[1]:amount,0);
    const textElement=(tag,text)=>{const el=document.createElement(tag);el.textContent=text;return el;};
    function orderStates(){return {...apparelViewStates,[apparelView]:snapshot()};}
    function shirtQuoteData(){
      const rows=shirtRows.map(r=>({variantId:r.variant.id,size:r.size,quantity:Number(r.input.value)||0,price:r.variant.price})).filter(r=>r.quantity>0);
      const quantity=rows.reduce((n,r)=>n+r.quantity,0),discount=discountFor(quantity);
      const states=orderStates(),locations=Object.entries(states).filter(([,v])=>v.length).map(([k])=>k);
      const sleeveLocations=locations.filter(k=>k==='leftSleeve'||k==='rightSleeve'),bodyLocations=locations.filter(k=>k==='front'||k==='back');
      const bodyExtras=Math.max(0,bodyLocations.length-1),extras=bodyExtras+sleeveLocations.length,subtotal=rows.reduce((n,r)=>n+r.price*r.quantity,0);
      return {shirt:shirtProduct?.title,handle:shirtProduct?.handle,color:apparelColor,rows,quantity,discountPerShirt:discount,subtotal,savings:discount*quantity,extraLocations:extras,bodyExtras,sleeveLocations,extraImprintTotal:extras*300*quantity,total:subtotal-discount*quantity+extras*300*quantity,locations};
    }
    function artworkLinkValid(value){
      try{const url=new URL(value);return url.protocol==='https:'&&!!url.hostname&&url.hostname.includes('.');}catch{return false;}
    }
    function updateArtworkNotice(){
      const link=$('[data-shirt-artwork-link]');
      const hasImages=currentProject==='apparel'&&Object.values(orderStates()).some(v=>v.some(n=>n.type==='Image'));
      const missing=hasImages&&!artworkLinkValid(link.value.trim());
      $('[data-artwork-steps]').hidden=!hasImages;
      link.setAttribute('aria-required',String(hasImages));
      if(!missing){link.removeAttribute('aria-invalid');$('#hgds-artwork-error').hidden=true;$('[data-artwork-link-field]').classList.remove('has-error');}
      const alert=$('[data-checkout-alert]');
      if(missing){
        alert.hidden=false;alert.dataset.artwork='1';
        $('[data-checkout-alert-title]').textContent=shirtStrings.artwork_needed_title;
        $('[data-checkout-alert-message]').textContent=shirtStrings.artwork_notice;
        $('[data-go-artwork]').hidden=false;
      }else if(alert.dataset.artwork==='1'){alert.hidden=true;delete alert.dataset.artwork;}
    }
    function showCheckoutError(message,artwork=false){
      const alert=$('[data-checkout-alert]');alert.hidden=false;
      alert.dataset.artwork=artwork?'1':'0';
      $('[data-checkout-alert-title]').textContent=artwork?shirtStrings.artwork_needed_title:shirtStrings.complete_step;
      $('[data-checkout-alert-message]').textContent=message;
      $('[data-go-artwork]').hidden=!artwork;
      alert.classList.remove('is-attention');void alert.offsetWidth;alert.classList.add('is-attention');
      if(artwork){const link=$('[data-shirt-artwork-link]');link.setAttribute('aria-invalid','true');$('#hgds-artwork-error').hidden=false;$('[data-artwork-link-field]').classList.add('has-error');}
      alert.scrollIntoView({behavior:'smooth',block:'center'});alert.focus({preventScroll:true});
    }
    function updateShirtSummary(){
      if(!shirtOrder)return;
      updateArtworkNotice();
      const summary=$('[data-shirt-summary]'),d=shirtQuoteData();summary.replaceChildren();
      for(const [label,value] of [[shirtStrings.quantity,String(d.quantity)],[shirtStrings.subtotal,money(d.subtotal)],[shirtStrings.tier,money(d.discountPerShirt)],[shirtStrings.savings,'−'+money(d.savings)],[shirtStrings.extra,money(d.extraImprintTotal)],[shirtStrings.total,money(d.total)]]){
        const row=textElement('p','');row.append(textElement('span',label),textElement('strong',value));summary.append(row);
      }
      const next=tiers.find(t=>t[0]>d.quantity);
      if(next)summary.append(textElement('small',shirtStrings.next.replace('{count}',next[0]-d.quantity).replace('{amount}',money(next[1]))));
      const qty=$('#hgds-qty');if(qty&&currentProject==='apparel'){qty.value=d.quantity||'';qty.readOnly=true;}
      $('[data-shirt-cart]').disabled=shirtBusy;
    }
    async function fetchShirt(handle,optionIds=[]){
      const route=window.Shopify?.routes?.root||'/';
      const url=new URL(route+'products/'+encodeURIComponent(handle),location.origin);
      url.searchParams.set('view','hg-studio-data');
      if(optionIds.length)url.searchParams.set('option_values',optionIds.join(','));
      const key=url.href;
      if(shirtCache.has(key))return shirtCache.get(key);
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error(shirtStrings.error);
      const data=await response.json();if(!data.id||!Array.isArray(data.options))throw new Error(shirtStrings.error);
      shirtCache.set(key,data);return data;
    }
    async function loadShirtStyle(){
      const request=++shirtRequest;shirtBusy=true;updateShirtSummary();
      $('[data-shirt-status]').textContent=shirtStrings.loading;
      try{
        await garmentImagesReady;
        const data=await fetchShirt($('[data-shirt-style]').value);
        if(request!==shirtRequest)return;
        const color=data.options.find(o=>/colou?r/i.test(o.name)),size=data.options.find(o=>/size/i.test(o.name));
        if(!color||!size)throw new Error(shirtStrings.error);
        shirtProduct=data;apparelColorSelect.replaceChildren();
        color.values.forEach(v=>apparelColorSelect.append(new Option(v.name,v.name)));
        apparelColor=color.values.some(v=>v.name===apparelColor)?apparelColor:color.values[0].name;
        apparelColorSelect.value=apparelColor;apparelColorLabel.textContent=apparelColor;
        $('[data-shirt-name]').textContent=data.title;
        const thumb=$('[data-project="apparel"] img');if(thumb){thumb.src=data.image;thumb.alt=data.title;}
        await loadShirtSizes();
      }catch(e){if(request===shirtRequest){shirtBusy=false;shirtRows=[];updateShirtSummary();$('[data-shirt-status]').textContent=shirtStrings.error;}}
    }
    async function loadShirtSizes(){
      if(!shirtProduct)return;
      const request=++shirtRequest;shirtBusy=true;updateShirtSummary();
      $('[data-shirt-status]').textContent=shirtStrings.loading;
      const color=shirtProduct.options.find(o=>/colou?r/i.test(o.name));
      const size=shirtProduct.options.find(o=>/size/i.test(o.name));
      const selectedColor=color.values.find(v=>v.name===apparelColor);
      const prior=new Map(shirtRows.map(r=>[r.size,r.input.value]));
      try{
        const options=await Promise.all(size.values.map(async sz=>{
          const data=await fetchShirt(shirtProduct.handle,[selectedColor.id,sz.id]);
          const v=data.variant;
          if(!v||v.options[color.position-1]!==apparelColor||v.options[size.position-1]!==sz.name)return null;
          return {size:sz.name,variant:v};
        }));
        if(request!==shirtRequest)return;
        shirtRows=[];const list=$('[data-shirt-sizes]');list.replaceChildren();
        list.append(textElement('small',shirtStrings.quantity+' / '+shirtStrings.each));
        options.filter(Boolean).forEach((r,index)=>{
          const row=textElement('div','');row.className='hgds__size-row';
          const input=document.createElement('input');input.type='number';input.min='0';input.max='10000';input.step='1';input.value=prior.get(r.size)||'0';
          input.id='hgds-shirt-quantity-'+index;input.setAttribute('aria-label',r.size+' '+shirtStrings.quantity);input.disabled=!r.variant.available;
          if(input.disabled)input.value='0';
          const label=textElement('label',r.size);label.htmlFor=input.id;
          row.append(label,textElement('span',r.variant.available?money(r.variant.price):shirtStrings.unavailable),input);
          r.input=input;shirtRows.push(r);list.append(row);input.addEventListener('input',()=>{if(!Number.isInteger(Number(input.value))||Number(input.value)<0)input.value='0';updateShirtSummary();});
        });
        const image=garmentViewImage();
        catalogImage=image;apparelColorLabel.textContent=apparelColor;apparelColorChip.style.setProperty('--shirt-color',shirtHex[apparelColor]||'#cccccc');
        shirtBusy=false;updateShirtSummary();draw();
        $('[data-shirt-status]').textContent=shirtStrings.ready;
      }catch(e){if(request===shirtRequest){shirtBusy=false;shirtRows=[];updateShirtSummary();$('[data-shirt-status]').textContent=shirtStrings.error;}}
    }
    function downloadShirtDesign(){
      const states=orderStates(),blob=new Blob([JSON.stringify({version:1,order:shirtQuoteData(),views:states,canvas:{width:stage.width(),height:stage.height()}},null,2)],{type:'application/json'});
      const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='HG-shirt-front-back-design.json';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
    }
    async function addShirtsToCart(){
      if(shirtBusy)return;
      const d=shirtQuoteData(),states=orderStates(),status=$('[data-shirt-status]');
      if(!d.quantity){showCheckoutError(shirtStrings.quantity_required);return;}
      if(!d.locations.length){showCheckoutError(shirtStrings.design_required);return;}
      const artwork=$('[data-shirt-artwork-link]').value.trim();
      const hasImages=Object.values(states).some(v=>v.some(n=>n.type==='Image'));
      const validLink=artworkLinkValid(artwork);
      if((hasImages||artwork)&&!validLink){showCheckoutError(shirtStrings.link_required,true);return;}
      const compact=Object.fromEntries(Object.entries(states).map(([k,v])=>[k,v.map(n=>({type:n.type,attrs:Object.fromEntries(Object.entries(n.attrs).filter(([key])=>!['sourceData','originalSourceData','image'].includes(key)))}))]));
      const specifications=JSON.stringify({views:compact,canvas:{width:stage.width(),height:stage.height()}});
      if(specifications.length>6000){showCheckoutError(shirtStrings.too_large);return;}
      const group=crypto.randomUUID(),properties={'Design Studio':'HG Shirt Studio','Design group':group,'Print locations':d.locations.join(', '),'Artwork link':artwork,'Design specifications':specifications};
      const items=d.rows.map(r=>({id:r.variantId,quantity:r.quantity,properties}));
      if(d.bodyExtras)items.push({id:40341153579086,quantity:d.quantity*d.bodyExtras,properties:{'Design group':group,'Shirt style':d.shirt,'Print locations':'Additional front/back'}});
      for(const sleeve of d.sleeveLocations)items.push({id:41528497504334,quantity:d.quantity,properties:{'Design group':group,'Shirt style':d.shirt,'Print locations':sleeve==='leftSleeve'?'Left sleeve':'Right sleeve'}});
      $('[data-checkout-alert]').hidden=true;
      shirtBusy=true;updateShirtSummary();status.textContent=shirtStrings.working;
      try{
        const route=window.Shopify?.routes?.root||'/';
        const response=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items}),credentials:'same-origin'});
        const result=await response.json();if(!response.ok)throw new Error(result.description||shirtStrings.cart_error);
        status.textContent=shirtStrings.added;location.assign(route+'cart');
      }catch(e){status.textContent=e.message;shirtBusy=false;updateShirtSummary();showCheckoutError(e.message);}
    }
    function initializeShirtOrder(){
      shirtOrder=$('[data-shirt-order]');if(!shirtOrder)return;
      shirtStrings=JSON.parse($('[data-shirt-strings]').textContent);
      $('[data-shirt-style]').addEventListener('change',loadShirtStyle);
      $('[data-shirt-download]').addEventListener('click',downloadShirtDesign);
      $('[data-shirt-cart]').addEventListener('click',addShirtsToCart);
      $('[data-shirt-artwork-link]').addEventListener('input',updateArtworkNotice);
      $('[data-go-artwork]').addEventListener('click',()=>{showCompact('order');const field=$('[data-artwork-link-field]');field.scrollIntoView({behavior:'smooth',block:'center'});$('[data-shirt-artwork-link]').focus({preventScroll:true});});
      form?.addEventListener('submit',()=>{if(currentProject==='apparel'){const input=document.createElement('input');input.type='hidden';input.name='contact[Shirt Order]';input.value=JSON.stringify(shirtQuoteData());form.append(input);}});
      const qty=$('#hgds-qty');if(qty)qty.addEventListener('focus',()=>{qty.readOnly=currentProject==='apparel'||currentProject==='hat';});
      const note=$('[data-apparel-view-note]');note.textContent=shirtStrings.back_note;
      loadShirtStyle();
    }

    apparelColorControl.hidden=false;
    apparelViewsControl.hidden=false;
    genericColorControl.hidden=true;
    apparelColorSelect.value=apparelColor;
    apparelColorLabel.textContent=apparelColor;
    apparelColorChip.style.setProperty('--shirt-color',shirtHex[apparelColor]||'#111111');


    let compactGroup='product',compactTabs;
    function showCompact(key){
      compactGroup=key;root.dataset.compactGroup=key;
      if(compactTabs)for(const button of compactTabs.children){const active=button.dataset.compactTab===key;button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;}
    }
    function syncCompactProject(){
      if(!compactTabs)return;
      $('[data-print-controls]').hidden=currentProject!=='apparel';$('[data-shirt-style]').closest('.hgds__field').hidden=currentProject!=='apparel';
      for(const button of compactTabs.children)button.hidden=button.dataset.compactTab==='order'&&currentProject!=='apparel';
      showCompact('product');
    }
    function initializeCompact(){
      const panel=$('.hgds__panel--left'),labels=JSON.parse($('[data-compact-strings]').textContent);
      compactTabs=document.createElement('div');compactTabs.className='hgds__compact-tabs';compactTabs.setAttribute('role','tablist');
      const field=s=>$(s)?.closest('.hgds__field');
      const group=(key,...nodes)=>nodes.filter(Boolean).forEach(node=>node.dataset.compactPanel=key);
      const styleField=field('[data-shirt-style]');panel.append(styleField);group('product',styleField);
      group('artwork',$('[data-print-controls]'),field('[data-aspect-lock]'),field('[data-background-color]'));
      group('text',field('[data-text-value]'),field('[data-font]'),field('[data-font-size]'));
      group('layers',$('.hgds__layers'));group('order',$('[data-shirt-order]'));
      for(const key of ['product','artwork','text','layers','order']){const button=document.createElement('button');button.type='button';button.dataset.compactTab=key;button.setAttribute('role','tab');button.textContent=new DOMParser().parseFromString(labels[key],'text/html').body.textContent;button.onclick=()=>showCompact(key);button.onkeydown=e=>{const buttons=[...compactTabs.children].filter(b=>!b.hidden);let i=buttons.indexOf(button);if(e.key==='ArrowRight')i=(i+1)%buttons.length;else if(e.key==='ArrowLeft')i=(i+buttons.length-1)%buttons.length;else return;e.preventDefault();buttons[i].click();buttons[i].focus();};compactTabs.append(button);}
      panel.prepend(compactTabs);syncCompactProject();
    }

    initializeShirtOrder();
    initializeHatOrder();
    initializeCompact();
    resize();
    saveHistory();
    renderLayers();
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();




